import React, { memo } from 'react';
import InputLabel from '@material-ui/core/InputLabel';

import classnames from 'classnames';
import IconButton from '@material-ui/core/IconButton';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import { TIME_HOUR, TIME_MINUTE } from '../TimePickerItems';
import DateTimeInput from '../../../../DateTimePicker/DateTimeInput/index';
import styles from '../index.module.scss';
import Tooltip, { InfoPropTypes } from 'components/Tooltip';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  inputLabel: {
    marginBottom: '0.5rem',
  },
  disabled: {
    color: `${theme.palette.text.disabled} !important`,
  },
  icon: {
    fontSize: '1.2rem',
    color: theme.palette.text.primary,
  },
}));

export const timeInputCategory = [
  {
    category: TIME_HOUR,
    max: 23,
    separator: ':',
    placeholder: 'HH',
  },
  {
    category: TIME_MINUTE,
    max: 55,
    step: 5,
    placeholder: 'mm',
  },
];

const TimePickerInput = ({
  required,
  label,
  onChange,
  toggleCalendar,
  time,
  className = '',
  disabled = false,
  error,
  timeInterval,
  info,
  maxMinuteInput,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const handleOnChange = event => {
    const category = event.target.getAttribute('category');
    const { value } = event.target;

    if (!isNaN(value)) {
      onChange({ category, value });
    }
  };

  return (
    <div className={classnames(styles.timepickerInputWrapper, className)}>
      <InputLabel
        shrink
        htmlFor="component-error"
        required={required}
        className={classes.inputLabel}
        classes={{ disabled: classes.disabled }}
        error={error}
        disabled={disabled}
      >
        {t(label)}
        {info && <Tooltip text={info} />}
      </InputLabel>
      <div className={styles.inputTime}>
        {timeInputCategory.map(
          ({ category, max, step = 1, placeholder }, index) => {
            return (
              <DateTimeInput
                key={category}
                date={time ? time[category] : ''}
                index={index}
                handleChange={handleOnChange}
                disabled={disabled}
                inputProps={{
                  max: maxMinuteInput || max,
                  category,
                  placeholder,
                  step: timeInterval || step,
                }}
                {...(timeInputCategory.length - 1 !== index && {
                  separator: ':',
                })}
              />
            );
          },
        )}
        {toggleCalendar && (
          <IconButton
            aria-label="Calendar"
            onClick={toggleCalendar}
            size="small"
            disabled={disabled}
          >
            <AccessTimeIcon className={classes.icon} />
          </IconButton>
        )}
      </div>

      <div className={styles.error}>{error}</div>
    </div>
  );
};

TimePickerInput.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  toggleCalendar: PropTypes.func,
  time: PropTypes.object,
  disabled: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  timeInterval: PropTypes.number,
  maxMinuteInput: PropTypes.number,
  info: InfoPropTypes,
};

export default memo(TimePickerInput);
